import { useMutation } from "@tanstack/react-query";
import { GET, POST } from "../services/index";

// admin ตรวจเคสเอง — นอกเหนือจากทาง Excel (Manual DEP) และทาง Panel report
// เคสหนึ่งมีผลตรวจได้ครั้งเดียว ตรวจซ้ำ = แก้ผลเดิม (backend upsert ให้)
export const useSaveCaseAudit = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/caseAudit`, payload),
  });
};

// สรุปเคสที่ผิดจริง รวมทุกช่องทาง
export const useFetchErrorSummary = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/caseAudit/summary`, payload),
  });
};

// รายละเอียดเคสเต็ม (รูปสลิป / customFields / history) คีย์ด้วย input_id
export const useFetchCaseDetail = () => {
  return useMutation({
    mutationFn: async (inputId) => {
      const { result } = await GET(`/api/v1/caseAudit/caseDetail/${inputId}`);
      return result;
    },
  });
};
